import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./OptionsAssetSelect.css";

export default function OptionsAssetSelect({ selectedAsset, wsUnderlyings, hasMarketData, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, width: 0 });
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        triggerRef.current && !triggerRef.current.contains(event.target) &&
        menuRef.current && !menuRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOpen = () => {
    if (!isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + 4,
        left: rect.left,
        width: rect.width
      });
    }
    setIsOpen(!isOpen);
  };

  const handleSelect = (symbol) => {
    onSelect(symbol);
    setIsOpen(false);
  };

  const selectedDisplay = hasMarketData && selectedAsset 
    ? wsUnderlyings.find(u => u.symbol === selectedAsset)?.underlying || selectedAsset 
    : "—";

  return (
    <>
      <div className="options-custom-select-trigger" onClick={toggleOpen} ref={triggerRef}>
        <span>{selectedDisplay}</span>
        <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
      </div>
      {isOpen && createPortal(
        <div 
          className="options-custom-select-menu" 
          ref={menuRef}
          style={{ position: 'fixed', top: menuPos.top, left: menuPos.left, minWidth: menuPos.width, width: 'auto' }}
        >
          {hasMarketData ? wsUnderlyings.map(u => (
            <div 
              key={u.symbol} 
              className={`options-custom-select-option ${selectedAsset === u.symbol ? 'selected' : ''}`}
              onClick={() => handleSelect(u.symbol)}
            >
              {u.underlying}
            </div>
          )) : (
            <div className="options-custom-select-option disabled">—</div>
          )}
        </div>,
        document.body
      )}
    </>
  );
}
